import { bool, shape, string, number } from 'prop-types';

// TODO: Needs revision after all payment methods are standarized
export const paymentMethodsPropTypes = shape({
  card: bool,
  cash: bool,
  ingenico: bool,
  onepay: bool,
  online: bool,
  sodexo: bool,
  webpay: bool
});

export const subsidiaryPropTypes = shape({
  id: number,
  name: string,
  textAddress: string,
  latitude: string,
  longitude: string,
  deliveryWaitTime: number,
  pickUpWaitTime: number
});
